import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class BackLink extends Component {
 
  render(){
    let prevPage = this.props.prevPage;

    return(
      <div className="row">
        <div className="large-12 columns">
          <div className="back-link-wrapper">
            <NavLink to={prevPage} className="back-link"><i className="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</NavLink>
          </div>
        </div>
      </div>

    );
  }
}
export default BackLink;


// WEBPACK FOOTER //
// ./src/components/pieces/BackLink.js